import { AppPage } from 'common/Layout';

export const HomePage = () => {
  return <AppPage pageTitle="Главная" documentTitle="Главная"></AppPage>;
};
